// dependencies
import { List } from "immutable";
import { getMatchedRouteKeyValue } from "yarrr";
import { GenerateProcess } from "redux-process";

// config
import config from "./config";

// ui
import ui from "./ui";

// actions
import { updateUI } from "Actions/ui";

// selectors
import { getPageName, getUI } from "Selectors/ui";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

export const getSnapshots = () => async (dispatch, getState) => {
	const state = getState();
	const currentUI = getUI(state);

	const request = await dispatch(
		GenerateProcess("getReviewReportSnapshots", {
			reportID: getMatchedRouteKeyValue(state, "reportID", ""),
			authorID: getMatchedRouteKeyValue(state, "authorID", ""),
			query: {
				sort: "-start_time",
				limit: config.pageSize,
				skip: (currentUI.get("currentPage", "") - 1) * config.pageSize,
			},
		})
	);

	const nextUI = currentUI.withMutations((mutable) => {
		mutable.setIn(["author"], request.response.getIn(["reviewSnapshot", "author"]));
		mutable.setIn(["review"], request.response.getIn(["reviewSnapshot", "review"]));
		mutable.setIn(["snapshots"], request.response.getIn(["reviewSnapshot", "snapshots"]));
		mutable.setIn(["review_report"], request.response.getIn(["reviewSnapshot", "review_report"]));
		mutable.setIn(["subject"], request.response.getIn(["reviewSnapshot", "subject"]));
		mutable.setIn(["totalCount"], request.response.getIn(["totalCount"]));
	});

	dispatch(changeUI([], nextUI));
};

export const init = () => (dispatch) => {
	dispatch(changeUI([], ui));
	dispatch(getSnapshots());
};

export const updateInput = (name, value) => (dispatch) => {
	dispatch(changeUI([name], value));
};

/**
 * Changes the page number and then fetches the data.
 *
 * @param {number} page - next page number
 */
export const changePage = (page) => async (dispatch) => {
	dispatch(changeUI(["currentPage"], page));
	await dispatch(getSnapshots());

	window.scrollTo(0, 0);
};
